import React, { useEffect, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Button, message, Upload, Tooltip, Form, Select } from "antd";
import * as XLSX from "xlsx";
import { fetchLab } from "../labPartner/FetchLab";
import { fetchTest } from "./FetchTest";
import { token } from "../../constants/Constants";
import { create_bulk_tests } from "../../endpoints/API";

const { Dragger } = Upload;

const BulkUploadTest = ({
  Lab,
  setIsBulkUploadModalOpen,
  setTest,
  baseUrl,
  prodTestUrl,
  onSuccess
}) => {
  const [fileList, setFileList] = useState([]); // State to track uploaded file
  const [loading, setLoading] = useState(false); // Upload button loading state
  const [lab, setLab] = useState(null);

  console.log(lab);
  const props = {
    name: "file",
    multiple: false,
    beforeUpload(file) {
      const isExcel =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";

      if (!isExcel) {
        message.error("You can only upload Excel files!");
        return Upload.LIST_IGNORE; // Prevent upload of non-Excel files
      }
      setFileList([file]); // Update state with selected file
      return false; // Prevent auto-upload
    },
    onRemove() {
      setFileList([]); // Clear the file when removed
    },
  };

  // Function to handle Excel parsing and sending data to server using fetch
  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.error("No file selected!");
      return;
    }

    setLoading(true);
    try {
      const file = fileList[0];
      const reader = new FileReader();

      // Read the file as binary string
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Assuming the first sheet is the target
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];

        // Convert the sheet to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // Extract columns and values
        const [columns, ...rows] = jsonData;
        const extractedData = rows?.map((row) => {
          const rowData = {};
          columns.forEach((col, index) => {
            rowData[col] = row[index] || null;
          });
          return rowData;
        });

        console.log("Extracted Data:", extractedData);

        // Send the extracted data to the server using fetch
        const response = await create_bulk_tests(extractedData, lab);

        if (!response.statusText=="OK") {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = response?.data;
        message.success("File uploaded and data sent successfully!");
        setIsBulkUploadModalOpen();
        onSuccess();
      };

      reader.readAsArrayBuffer(file); // Read the file
    } catch (error) {
      message.error(error?.response?.data?.error||"Error uploading file. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Form>
        <div className="mb-[1rem] mt-[1rem] w-full">
          <Select
            placeholder="Select Lab"
            style={{ width: "100%" }}
            onChange={(value) => setLab(value)}
          >
            {Lab?.map((labItem) => (
              <Select.Option key={labItem.id} value={labItem.id}>
                {labItem.name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Dragger {...props} fileList={fileList}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single Excel file upload. Strictly prohibited from
            uploading company data or other banned files.
          </p>
        </Dragger>

        <div className="flex justify-end mt-[1rem]">
          <Tooltip
            title={!lab ? "Select lab" : !fileList.length ? "Upload file" : ""}
            placement="top"
          >
            <Button
              className="mr-[1rem]"
              type="primary"
              onClick={handleUpload}
              disabled={!fileList.length || !lab}
              loading={loading}
            >
              Upload
            </Button>
          </Tooltip>
          <Button
            type="primary"
            onClick={() => {
              // Construct the file path from the public folder
              const fileUrl = `${process.env.PUBLIC_URL}/test_sample.xlsx`;

              // Create an anchor element dynamically
              const link = document.createElement("a");
              link.href = fileUrl; // Set the href to the file's path
              link.download = "test_sample.xlsx"; // Set the desired file name for download
              document.body.appendChild(link); // Append the link to the body
              link.click(); // Programmatically click the link to trigger download
              document.body.removeChild(link); // Clean up by removing the link
            }}
          >
            Download Sample
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default BulkUploadTest;
